import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TextField, Button, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { AuthContext } from '../../contexts/AuthContext';

const ChangePasswordPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { user: contextUser, setUser } = useContext(AuthContext);

  const user = location.state?.user || contextUser;

  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');

  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);

    if (!minLength) return 'パスワードは最低8文字必要です。';
    if (!hasLowercase) return 'パスワードには小文字（a〜z）を含めてください。';
    if (!hasNumber) return 'パスワードには数字（0〜9）を含めてください。';

    return '';
  };

  const handleChangePassword = async () => {
    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    try {
      await Auth.completeNewPassword(user, newPassword);
      const signedInUser = await Auth.signIn(user.username, newPassword);
      setUser(signedInUser);
      history.push('/signin/verify-email');
    } catch (err) {
      console.error('Password Change Error:', err);
      setError('パスワードの変更に失敗しました');
    }
  };

  if (!user) {
    return <Typography>不正なアクセスです。</Typography>;
  }

  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: 20 }}>
      <Typography variant="h6" gutterBottom>
        仮パスワードでの初回ログインありがとうございます。
        <br />
        新しいパスワードを設定してください。
      </Typography>

      <TextField
        label="新しいパスワード"
        type="password"
        fullWidth
        margin="normal"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <Typography variant="body2" style={{ marginTop: 10 }}>
        このあと、ご登録のメールアドレスに認証コードをお送りします。
      </Typography>

      {error && (
        <Typography color="error" variant="body2" style={{ marginTop: 10 }}>
          {error}
        </Typography>
      )}

      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleChangePassword}
        style={{ marginTop: 20 }}
      >
        パスワードを変更して認証コードを送信
      </Button>
    </div>
  );
};

export default ChangePasswordPage;
